<template>
    <div>
        <div class="audio-gauge-base">
            <div 
                class="audio-gauge-overlay"
                :style="{'height': setOverlayHeight}"
            ></div>

            <div class="audio-gauge-level red-bg"></div>
            <div class="audio-gauge-level red-bg"></div>
            <div class="audio-gauge-level red-bg"></div>
            <div class="audio-gauge-level red-bg"></div>
            <div class="audio-gauge-level red-bg"></div>
            <div class="audio-gauge-level red-bg"></div>

            <div class="audio-gauge-level orange-bg"></div>
            <div class="audio-gauge-level orange-bg"></div>
            <div class="audio-gauge-level orange-bg"></div>
            <div class="audio-gauge-level orange-bg"></div>
            <div class="audio-gauge-level orange-bg"></div>

            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>

            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>
            <div class="audio-gauge-level green-bg"></div>
        </div>
        <div class="channel-position">{{channel.position}}</div>
    </div>
</template>

<script>
    export default{
        name: 'MonoChannelLevel',
        props: {
            channel: {
                type: Object,
                required: true,
            }
        },
        computed: {
            setOverlayHeight(){
                let heightPrecentage = 100* (-this.channel.level) /60;
                if (heightPrecentage > 100){
                    heightPrecentage = 100;
                }
                return `calc(${heightPrecentage}% + 5px)`;
            }
        }
    };
</script>

<style>
    .audio-gauge-level{
        height:  3px;
        width:  15px;
        border-radius: 20px;
    }
    .green-bg{
        background-color: #00cc00;
    }
    .orange-bg{
        background-color: #ff8000;
    }
    .red-bg{
        background-color: #ff0000;
    }
    .audio-gauge-overlay{
        position: absolute;
        width:  100%;
        height:  100%;
        background-color: white;
        opacity: 0.8;
    }
    .audio-gauge-base{
        background-color: white;
        width: 20px;
        height: 150px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        position: relative;
        padding: 0 1rem;
    }
    .channel-position{
        text-align: center;
        font-size: 12px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Preview/PreviewAudio/mono-channel-level.vue